import { type OrderDto } from '@/shared/api/order';
import { toFormValues } from './mappers/toFormValues';
import { ORDER_FORM_ID } from '../constants';
import { orderForm } from '../model/forms/orderForm';
import { getOrderItemsSignature } from './getOrderItemsSignature';

export const reinitializeOrderForm = (initialOrder: OrderDto, updatedOrder: OrderDto) => {
    const formInstance = orderForm.getInstance(ORDER_FORM_ID);

    if (!formInstance.isInitialized()) {
        return;
    }

    const initialOrderItemsSignature = getOrderItemsSignature(initialOrder.delivery_chunks);
    const updatedOrderItemsSignature = getOrderItemsSignature(updatedOrder.delivery_chunks);

    if (initialOrderItemsSignature === updatedOrderItemsSignature) {
        formInstance.reinitialize(formInstance.getValue());
    } else {
        const updatedFormValues = toFormValues(updatedOrder);

        formInstance.reinitialize({
            ...formInstance.getValue(),
            deliveryCourierInterval: updatedFormValues?.deliveryCourierInterval,
            deliveryPickupPointInterval: updatedFormValues?.deliveryPickupPointInterval,
            deliverySelfPickUpInterval: updatedFormValues?.deliverySelfPickUpInterval,
        });
    }
};
